var map = {
	"./cart.vue": "3eaf",
	"./dialog-cancel.vue": "8a9e",
	"./dialog-loading.vue": "26b5",
	"./dialog-logout.vue": "534c",
	"./dialog-remove.vue": "c150",
	"./dialog-warning-navigation.vue": "147e",
	"./drawer-menu.vue": "eee7",
	"./drawer-user.vue": "9b6c",
	"./footer-component.vue": "dace",
	"./location-item.vue": "0123",
	"./location-list-2.vue": "b8dc",
	"./location-list-data.vue": "46c1",
	"./location-list.vue": "fa1e",
	"./product-list.vue": "3bb6",
	"./review-headline.vue": "5f8e",
	"./review-products.vue": "c04a",
	"./snack.vue": "8acb",
	"./toolbar-component.vue": "e470"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bff8";